export default __webpack_public_path__ + "static/media/phaphrom_img6.06b6a015.webp";